export enum SignInState {
    SignedOut = 'SignedOut',
    InProgress = 'InProgress',
    SignedIn = 'SignedIn',
}
